import React from "react";
import { DA_ContentBox } from "@danishagro/shared/src/components/atoms/ContentBox/ContentBox.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { useScreen } from "@danishagro/shared/src/contexts/screen.context";
import { DA_BasicLink } from "@danishagro/shared/src/components/atoms/BasicLink/BasicLink.component";
import { DA_Icon, DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_OrderHistory } from "@danishagro/shared/src/interfaces/orderHistory.interface";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { OrderDetailsSubtotal } from "../OrderDetailsSubtotal/OrderDetailsSubtotal.component";
import { OrderDetailsProduct } from "../OrderDetailsProduct/OrderDetailsProduct.component";
import S from "./OrderDetails.module.scss";

export const OrderDetails = ({ ...props }: DA_OrderHistory) => {
    const { getDictionaryString } = useTranslations();
    const { isMobileOrTablet } = useScreen();
    const { siteVariant } = useAppData();

    const deliveryAddress = (
        <>
            <span>{props.shippingDetails.shippingAddress.name}</span>
            <span>{props.shippingDetails.shippingAddress.address}</span>
            <span>
                {props.shippingDetails.shippingAddress.zipCode}{" "}
                {props.shippingDetails.shippingAddress.city}
            </span>
            <span>{props.shippingDetails.shippingAddress.country}</span>
        </>
    );

    const invoiceAddress = (
        <>
            <span>{props.invoiceDetails?.invoiceAddress.name}</span>
            <span>{props.invoiceDetails?.invoiceAddress.address}</span>
            <span>
                {props.invoiceDetails?.invoiceAddress.zipCode}{" "}
                {props.invoiceDetails?.invoiceAddress.city}
            </span>
            <span>{props.invoiceDetails?.invoiceAddress.country}</span>
        </>
    );
    return (
        <div className={S.orderDetailsWrapper}>
            <div className={S.orderDetailsContainer}>
                {/* Delivery */}
                <DA_ContentBox
                    className={S.delivery}
                    mediumVerticalPadding
                    noMargin
                    noBorderRadius={isMobileOrTablet}
                    noShadow={isMobileOrTablet}
                    noBackgroundColor={isMobileOrTablet}
                >
                    <DA_Title h4>{getDictionaryString("profile.orderHistory.delivery")}</DA_Title>
                    <div className={S.details}>
                        <div className={S.detailsData}>
                            <b>{getDictionaryString("profile.orderHistory.deliveryAddress")}</b>
                            {deliveryAddress}
                        </div>
                        <div className={S.detailsData}>
                            <b>{getDictionaryString("profile.orderHistory.deliveryMethod")}</b>
                            <span>
                                {getDictionaryString(
                                    `reciept.deliveryMethod.${props.data.deliveryMethod}`
                                )}
                            </span>
                        </div>
                    </div>

                    {props.data?.checkoutComment ? (
                        <div className={S.comment}>
                            <strong>{getDictionaryString("reciept.comment")}</strong>
                            <div>{props.data?.checkoutComment}</div>
                        </div>
                    ) : null}
                </DA_ContentBox>

                {isMobileOrTablet && <div className={S.separator} />}

                {/* Payment */}
                <DA_ContentBox
                    className={S.payment}
                    mediumVerticalPadding
                    noMargin
                    noBorderRadius={isMobileOrTablet}
                    noShadow={isMobileOrTablet}
                    noBackgroundColor={isMobileOrTablet}
                >
                    <DA_Title h4>{getDictionaryString("profile.orderHistory.payment")}</DA_Title>
                    <div className={S.details}>
                        <div className={S.detailsData}>
                            <b>{getDictionaryString("profile.orderHistory.billingAddress")}</b>
                            {props.invoiceDetails !== null ? invoiceAddress : deliveryAddress}
                        </div>
                        <div className={S.detailsData}>
                            <b>{getDictionaryString("profile.orderHistory.paymentMethod")}</b>
                            <span>
                                {getDictionaryString(
                                    `reciept.paymentMethod.${props.data.paymentMethod}`
                                )}
                            </span>
                        </div>
                    </div>
                </DA_ContentBox>

                {isMobileOrTablet && <div className={S.separator} />}

                {/* Order details */}
                <DA_ContentBox
                    className={S.orderDetails}
                    mediumVerticalPadding
                    noMargin
                    noBorderRadius={isMobileOrTablet}
                    noShadow={isMobileOrTablet}
                    noBackgroundColor={isMobileOrTablet}
                >
                    <DA_Title h4>
                        {getDictionaryString("profile.orderHistory.orderDetails")}
                    </DA_Title>

                    <OrderDetailsProduct lines={props.lines} />
                </DA_ContentBox>
            </div>

            <div className={S.subtotalwrapper}>
                {/* Subtotal */}
                <DA_ContentBox
                    className={S.subtotal}
                    mediumVerticalPadding
                    noMargin
                    noBorderRadius={isMobileOrTablet}
                    noShadow={isMobileOrTablet}
                    noBackgroundColor={isMobileOrTablet}
                >
                    <OrderDetailsSubtotal {...props.data.prices} />
                </DA_ContentBox>

                {/* Download button */}
                {/* TODO: add download */}
                <div className={S.downloadBtn}>
                    {siteVariant?.alias !== "hatting-agro-b2b" &&
                        siteVariant?.alias !== "danish-agro-b2c" && (
                            <DA_BasicLink className={S.btn} href="">
                                <DA_Icon name={DA_IconNames.Document} />
                                {getDictionaryString("profile.orderHistory.download")}
                            </DA_BasicLink>
                        )}
                </div>
            </div>
        </div>
    );
};
